import * as React from "react";
import * as SC from "./styles";

export default ({ mail }) => {
  if (!mail) {
    return "-";
  }
  return <SC.ATag href={`mailto:${mail}`}>{mail}</SC.ATag>;
};
